import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { AuthFacade } from '../../store/auth.facade';

@Component({
  standalone: false,
  selector: 'app-auth-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  public loginValid = true;
  public newPassword = '';
  public newPasswordConfirm = '';
  public mailToken = '';
  
  isLoading$ = this.authFacade.isLoadingLogin$;
  showLoginError$ = this.authFacade.hasLoginError$;

  constructor(
    private authFacade: AuthFacade, 
    private route: ActivatedRoute) {
     }

  ngOnInit() {
    let mailTokenKey = 'key'
    this.route.queryParams.subscribe(params => {
      this.mailToken = params[mailTokenKey];
    });
  }

  onSubmit() {
    this.authFacade.passwordReset(this.newPassword,
                                  this.newPasswordConfirm,
                                  this.mailToken);
  }
}
